import { render, staticRenderFns } from "./incoTerm.vue?vue&type=template&id=748b4f22&"
import script from "./incoTerm.vue?vue&type=script&lang=js&"
export * from "./incoTerm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('748b4f22')) {
      api.createRecord('748b4f22', component.options)
    } else {
      api.reload('748b4f22', component.options)
    }
    module.hot.accept("./incoTerm.vue?vue&type=template&id=748b4f22&", function () {
      api.rerender('748b4f22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Information/components/basicData/incoTerm.vue"
export default component.exports